/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gamecompanies_Konami1Inputs */

const ja_gamecompanies_konami1 = /** @type {(inputs: Gamecompanies_Konami1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konami`)
};

const en_gamecompanies_konami1 = /** @type {(inputs: Gamecompanies_Konami1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konami`)
};

/**
* | output |
* | --- |
* | "Konami" |
*
* @param {Gamecompanies_Konami1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const gamecompanies_konami1 = /** @type {((inputs?: Gamecompanies_Konami1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gamecompanies_Konami1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_gamecompanies_konami1(inputs)
	return en_gamecompanies_konami1(inputs)
});
export { gamecompanies_konami1 as "gameCompanies_konami" }